module.exports = __webpack_public_path__ + "img/trailblazer-full.2b8620e8.png";